import { EventWithDetail, QueryEventsRequest } from "@garther/interfaces";
import { Spinner } from "@garther/ui/components";
import { cn } from "@garther/ui/libs";
import { useNavigate } from "@tanstack/react-router";

import { useEventsPagination } from "@/hooks/queries/use-events-query";

import { EventCard } from "./event-card";
import { Pagination } from "./pagination";

type EventsProps = Partial<Omit<QueryEventsRequest, "page">> & {
  classname?: string;
  enablePagination?: boolean;
};

export function Events({ classname, enablePagination = true, ...filters }: EventsProps) {
  const navigate = useNavigate();

  const { events, isLoading, error, pagination, setPage, currentPage } = useEventsPagination({
    enabled: true,
    ...filters,
    limit: filters.limit ?? 6
  });

  const handleEventSelect = (eventId: string) => {
    navigate({ to: "/org/$orgId/event/$eventId", params: { orgId: filters.hostId ?? "", eventId } });
  };

  if (isLoading) {
    return (
      <div className="w-full min-h-[50vh] flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div className="w-full space-y-4">
      <div
        className={cn("grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 md:gap-2 lg:gap-6", classname)}
      >
        {events.map((event: EventWithDetail) => (
          <EventCard key={event.id} event={event} onSelect={handleEventSelect} />
        ))}
      </div>

      {/* Pagination */}
      {enablePagination && pagination && (
        <Pagination currentPage={currentPage} totalPages={pagination.totalPages} onPageChange={setPage} />
      )}
    </div>
  );
}
